import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RecipeState } from './recipe-state';
import { CookbookState } from './cookbook-state';
import { TabsState } from './tabs-state';
import { UserPreferences } from 'app/services/api-service/user-data-service/user-data-service-types';

@Injectable({
  providedIn: 'root',
})
export class UserState {
  private isLoggedIn = new BehaviorSubject<boolean>(false);
  private usernameSubject = new BehaviorSubject<string>('');
  private groupsSubject = new BehaviorSubject<string[]>([]);
  private preferencesSubject = new BehaviorSubject<UserPreferences | undefined>(undefined);
  loggedIn = this.isLoggedIn.asObservable();
  username = this.usernameSubject.asObservable();
  groups = this.groupsSubject.asObservable();
  preferences = this.preferencesSubject.asObservable();
  private recipes?: number;

  constructor(
    private recipeState: RecipeState,
    private cookBookState: CookbookState,
    private tabState: TabsState,
  ) {}

  clearRecipeCaches() {
    this.recipeState.clearCache();
    this.cookBookState.clearCache();
    this.tabState.clearTabs();
    this.clearCurrentRecipeCount();
  }

  setIsLogin(state: boolean) {
    if (this.getIsLogin() !== state) {
      this.isLoggedIn.next(state);
      this.clearRecipeCaches();
    }
  }

  getIsLogin() {
    return this.isLoggedIn.value;
  }

  setGroups(state: string[]) {
    this.groupsSubject.next(state);
  }

  isInGroup(group: string) {
    return this.groupsSubject.value.includes(group);
  }

  setUsername(username: string) {
    this.usernameSubject.next(username);
  }

  getUsername() {
    return this.usernameSubject.value;
  }

  getCurrentRecipeCount(): number | undefined {
    return this.recipes;
  }

  setCurrentRecipeCount(count: number) {
    this.recipes = count;
  }

  clearCurrentRecipeCount() {
    this.recipes = undefined;
  }

  setPreferences(preferences: UserPreferences) {
    this.preferencesSubject.next(preferences);
  }

  clearPreferences() {
    this.preferencesSubject.next(undefined);
  }

  getCurrentPreferences() {
    return this.preferencesSubject.value;
  }
}
